import React from "react";
import { Container, Grid } from "@material-ui/core";

const Home: React.FC = () => {
	// TODO: split styling out into separate files, and pages into dedicated folders (Home/SearchResults/OrderDetails)
	return (
		<Container maxWidth={false}>
			<Grid
				container
				spacing={2}
				direction="column"
				justifyContent="center"
				alignContent="center"
				style={{ minHeight: "80vh" }}
			>
				{/* <Grid item xs={11} sm={10}>
					<Typography variant="h4" component="div">
						Search
					</Typography>
				</Grid> */}
				{/* <Grid item xs={11} sm={10}>
					<SearchBar />
				</Grid> */}
			</Grid>
		</Container>
	);
};

export default Home;
